import React from "react"
import styled, { createGlobalStyle } from "styled-components"

import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Theme from "./theme"
import SEO from "./seo"
import Footer from "./footer"
import HeroShape from "../static/hero-shape.svg"

const GlobalStyles = createGlobalStyle`

* {
  box-sizing: border-box;
}

#hero {
  display: flex;
  align-items: flex-end;
  flex-flow: column;
  .inner {
    max-width: 100%;
    padding: 0;
  }
  
  @media (max-width: ${({ theme }) => theme.lg}) {
    &::before, &::after {
    width: 100%;
    height: 360px;
    background-position:  center;
    }
    .logo {
      margin-left: 1.875rem;
    }
  }


  @media (max-width: ${({ theme }) => theme.lg}) {
    padding-top: 300px;  

    #hero-text {
      padding-top: 2rem;
      background-image: url(${HeroShape});
      background-repeat: no-repeat;
      background-size: 400% 100%;
      background-position: top left 15%;
    }
  }

  h1 {
    margin-top: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.md}) {
    .inner {
      flex-direction: column;
    }
  }


  @media (min-width: ${({ theme }) => theme.lg}) {
    .inner {
      margin-top: auto;
      flex-flow: row;
    }

    &::before {
      height: 100%;
      background-position:  center;
      background-size: cover;
    }
    .inner {
      background-image: url(${HeroShape});
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: 100% 60%;
      padding: 1.25rem 7%;
    }
  }

}

#custom-wellness-plans {
  display: flex !important;
  flex-flow: column;
  width: 100%;
  padding: 15rem 1.5rem;
  justify-content: center;
  align-items: center;

  h2 {
    margin-bottom: 0.5rem;
  }

  p {
    padding: 0;
  }



  @media (min-width: ${({ theme }) => theme.lg}) {
    padding: 7rem 0;
    &::before {
      background-size: 507px;
      background-position: -277px center, calc(100% + 277px) center;
    }
  }

  @media (max-width: ${({ theme }) => theme.lg}) {
    &::before {
      background-size: 507px;
      background-position: center -277px, center calc(100% + 277px);
    }
  }

}

#how-livea-works {
  padding-top: 4.625rem;
}

@media (min-width: ${({ theme }) => theme.md}) {
  padding-top: 0;
  .inner {
    max-width: 68rem;
    margin: 0 auto;
  }

  #see-livea .jenn {
    min-width: 514px;
    margin: 0;
  }
}

#see-livea {
  padding-top: 1rem;
  .inner {
    justify-content: center;
  }

}
  .jenn {
    margin: 2rem 1rem;
    min-width: 300px;
    min-height: 580px;
  }
`

export default function Layout({ children }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const siteTitle = data.site.siteMetadata?.title || `Page Title`

  return (
    <Theme>
      <GlobalStyles />
      <SEO title={siteTitle} />
      <main>{children}</main>
      <Footer siteTitle={siteTitle} />
    </Theme>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const Grid = styled.div``

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: ${({ justify }) => justify};
  align-items: ${({ align }) => align};

  @media (min-width: ${({ theme }) => theme.md}) {
    flex-direction: row;
  }
`

const Column = styled.div`
  flex: 1 0 100%;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.md}) {
    flex: ${({ $size }) => $size};
  }
`

export { Grid, Row, Column }
